import Chart from 'chart.js'
import pattern from 'patternomaly'
import chroma from 'chroma-js'
import download from 'downloadjs'
import moment from 'moment'

export default {
  name: 'Chart',
  props: ['report', 'elementId'],
  components: {},
  mounted () {
    Chart.plugins.register({
      beforeDraw: function (chartInstance) {
        var ctx = chartInstance.chart.ctx
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height)
      }
    })
  },
  data () {
    return {
      chartType: 'doughnut',
      showMousePointer: false,
      chartOptions: {
        animation: { duration: 0 },
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2,
        legend: {
          display: true,
          position: 'right',
          labels: {
            boxWidth: 20
          }
        },
        tooltips: {
          displayColors: false,
          mode: 'nearest',
          intersect: true
        },
        hover: {
          mode: 'nearest',
          intersect: true,
          onHover: (event, chartElement) => {
            this.mouseHover(event, chartElement)
          }
        },
        title: {
          display: this.report.name != null,
          text: this.report.name,
          position: 'top',
          fontFamily: 'Rubik',
          fontStyle: 'normal',
          fontSize: 24
        },
        onClick: (event, item) => {
          this.clickChart(event, item)
        }
      },
      activeCharts: null,
      chartData: null
    }
  },
  computed: {
    chartStyle () {
      var style = {}
      if (this.chartData != null) {
        style.display = 'block'
      } else {
        style.display = 'none'
      }
      if (this.showMousePointer) {
        style.cursor = 'pointer'
      } else {
        style.cursor = 'default'
      }
      return style
    }
  },
  methods: {
    colors (count) {
      var colors = []
      for (var i = 0; i < count; i++) {
        colors.push(this.color(i))
      }
      return colors
    },
    color (index) {
      const bases = ['#19A8A6', '#36CC9E', '#EBD98E', '#DD993F', '#E25660']
      const shapes = [null, 'dot', 'weave', 'cross', 'diagonal', 'diagonal-right-left']
      const base = bases[index % bases.length]
      const shape = shapes[Math.floor(index / bases.length) % shapes.length]
      if (shape != null) {
        return pattern.draw(shape, chroma(base).darken(0.2), chroma(base).brighten(0.5).hex())
      } else {
        return base
      }
    },
    draw () {
      setTimeout(() => {
        if (this.chartData) {
          if (this.activeChart) {
            this.activeChart.data = this.chartJsData
            this.activeChart.update()
          } else {
            this.activeChart = new Chart(document.getElementById(this.elementId), {
              type: this.chartType,
              data: this.chartJsData,
              options: this.chartOptions
            })
          }
        }
      }, 100)
    },
    saveImage () {
      const url = document.getElementById(this.elementId).toDataURL('image/png')
      download(url, 'chart.png', 'img/png')
    },
    copyImageToClipboard () {
    },
    viewData () {
      this.$router.push({ path: '/reporting/report', query: { filters: this.filters, group: this.groupBy, type: this.chartType } })
    },
    mouseHover (event, item) {
      this.showMousePointer = (item.length > 0 && item[0] != null)
    },
    clickChart (event, item) {
      console.log('Chart clicked with no action')
    },
    selectLink (link) {
      this.$emit('selectLink', link)
    },
    subtitle () {
      return 'Data correct as of ' + moment().format('L')
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/mixins/Chart.js